import jsPDF from "jspdf";
import logoGente from "../../../src/imagens/20191205 - Logo GENTE.png";
import logoPrefeitura from "../../../src/imagens/prefeitura_ouro_preto_logo_1.png";
import Api from "../../services/Api";

class PdfHealth {
  static async gerarRelatorio(
    distrito,
    healthMapImage,
    frequenciaExame,
    atendimentoAmbulancia,
    sistemaSaude,
    usoMedicamento,
    dificuldadeAtendimento,
    possuiDoencaCronica,
    tipoDoencaCronica,
    programaSaudeRural,
    frequenciaExameImage,
    atendimentoAmbulanciaImage,
    sistemaSaudeImage,
    usoMedicamentoImage,
    dificuldadeAtendimentoImage,
    qualidadeSSMunicipalImage,
    qualidadeSSRuralImage,
    possuiDoencaCronicaImage,
    tipoDoencaCronicaImage,
    programaSaudeRuralImage,
  ) {
    const propriedades = await Api.getNumeroPropriedadesSaude(
      distrito,
      frequenciaExame,
      atendimentoAmbulancia,
      sistemaSaude,
      usoMedicamento,
      dificuldadeAtendimento,
      possuiDoencaCronica,
      tipoDoencaCronica,
      programaSaudeRural,
    );

    const [
      frequenciaExameData,
      atendimentoAmbulanciaData,
      sistemaSaudeData,
      usoMedicamentoData,
      dificuldadeAtendimentoData,
      qualidadeSSMunicipalData,
      qualidadeSSRuralData,
      possuiDoencaCronicaData,
      tipoDoencaCronicaData,
      programaSaudeRuralData,
    ] = await Promise.all([
      Api.getFrequenciaExame(
        distrito,
        null,
        atendimentoAmbulancia,
        sistemaSaude,
        usoMedicamento,
        dificuldadeAtendimento,
        possuiDoencaCronica,
        tipoDoencaCronica,
        programaSaudeRural,
      ),
      Api.getAtendimentoAmbulancia(
        distrito,
        frequenciaExame,
        null,
        sistemaSaude,
        usoMedicamento,
        dificuldadeAtendimento,
        possuiDoencaCronica,
        tipoDoencaCronica,
        programaSaudeRural,
      ),
      Api.getSistemaSaude(
        distrito,
        frequenciaExame,
        atendimentoAmbulancia,
        null,
        usoMedicamento,
        dificuldadeAtendimento,
        possuiDoencaCronica,
        tipoDoencaCronica,
        programaSaudeRural,
      ),
      Api.getUsoMedicamento(
        distrito,
        frequenciaExame,
        atendimentoAmbulancia,
        sistemaSaude,
        null,
        dificuldadeAtendimento,
        possuiDoencaCronica,
        tipoDoencaCronica,
        programaSaudeRural,
      ),
      Api.getDificuldadeAtendimento(
        distrito,
        frequenciaExame,
        atendimentoAmbulancia,
        sistemaSaude,
        usoMedicamento,
        null,
        possuiDoencaCronica,
        tipoDoencaCronica,
        programaSaudeRural,
      ),
      Api.getQualidadeSSMunicipal(
        distrito,
        frequenciaExame,
        atendimentoAmbulancia,
        sistemaSaude,
        usoMedicamento,
        dificuldadeAtendimento,
        possuiDoencaCronica,
        tipoDoencaCronica,
        programaSaudeRural,
      ),
      Api.getQualidadeSSRural(
        distrito,
        frequenciaExame,
        atendimentoAmbulancia,
        sistemaSaude,
        usoMedicamento,
        dificuldadeAtendimento,
        possuiDoencaCronica,
        tipoDoencaCronica,
        programaSaudeRural,
      ),
      Api.getPossuiDoencasCronicas(
        distrito,
        frequenciaExame,
        atendimentoAmbulancia,
        sistemaSaude,
        usoMedicamento,
        dificuldadeAtendimento,
        null,
        tipoDoencaCronica,
        programaSaudeRural,
      ),
      Api.getTipoDoencasCronicas(
        distrito,
        frequenciaExame,
        atendimentoAmbulancia,
        sistemaSaude,
        usoMedicamento,
        dificuldadeAtendimento,
        possuiDoencaCronica,
        null,
        programaSaudeRural,
      ),
      Api.getProgramaSaudeRural(
        distrito,
        frequenciaExame,
        atendimentoAmbulancia,
        sistemaSaude,
        usoMedicamento,
        dificuldadeAtendimento,
        possuiDoencaCronica,
        tipoDoencaCronica,
        null,
      ),
    ]);

    const doc = new jsPDF();
    const imgSize = 64;

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageOne(
      doc,
      distrito,
      propriedades,
      frequenciaExame,
      atendimentoAmbulancia,
      sistemaSaude,
      usoMedicamento,
      dificuldadeAtendimento,
      possuiDoencaCronica,
      tipoDoencaCronica,
      programaSaudeRural,
      healthMapImage,
    );

    doc.addPage();

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageTwo(
      doc,
      propriedades.value,
      frequenciaExameImage,
      atendimentoAmbulanciaImage,
      sistemaSaudeImage,
      frequenciaExameData.value,
      atendimentoAmbulanciaData.value,
      sistemaSaudeData.value,
      imgSize,
    );

    doc.addPage();
    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageThree(
      doc,
      propriedades.value,
      usoMedicamentoImage,
      dificuldadeAtendimentoImage,
      qualidadeSSMunicipalImage,
      usoMedicamentoData.value,
      dificuldadeAtendimentoData.value,
      qualidadeSSMunicipalData.value,
      imgSize,
    );

    doc.addPage();
    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageFour(
      doc,
      propriedades.value,
      qualidadeSSRuralImage,
      possuiDoencaCronicaImage,
      tipoDoencaCronicaImage,
      qualidadeSSRuralData.value,
      possuiDoencaCronicaData.value,
      tipoDoencaCronicaData.value,
      imgSize,
    );

    doc.addPage();
    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageFive(
      doc,
      propriedades.value,
      programaSaudeRuralImage,
      programaSaudeRuralData.value,
      imgSize,
    );

    const fileName =
      "Relatorio_Saude_" + distrito + "_" + this.dataAtual() + ".pdf";
    doc.save(fileName);
  }

  static pageOne(
    doc,
    distrito,
    propriedades,
    frequenciaExame,
    atendimentoAmbulancia,
    sistemaSaude,
    usoMedicamento,
    dificuldadeAtendimento,
    possuiDoencaCronica,
    tipoDoencaCronica,
    programaSaudeRural,
    healthMapImage,
  ) {
    // Considerações Iniciais
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Considerações iniciais", 10, 40);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    const consideracoes = `      As informações e dados contidas no presente relatório foram extraídas através do dashboard oficial do Censo Agropecuário de Ouro Preto – MG. O Censo Agropecuário foi uma das principais etapas do Plano Municipal de Desenvolvimento Rural de Ouro Preto, projeto desenvolvido pela Secretaria Municipal de Agropecuária em parceria com a Universidade Federal de Viçosa. O objetivo central do Censo Agropecuário consistiu na busca de informações sobre os estabelecimentos e as atividades agropecuárias, caracterizando o produtor e o estabelecimento, a economia e emprego no meio rural, a pecuária, a lavoura e a agroindústria. Todo o processo foi realizado a partir da aplicação do Boletim de Cadastro Rural (BCR), formulário estruturado para caracterizar as propriedades, a infraestrutura rural, as condições socioeconômicas dos produtores e as atividades desenvolvidas. A seguir serão sintetizados alguns dados do Censo Agropecuário em formas de tabelas, gráficos e mapas.`;
    doc.text(consideracoes, 10, 50, { maxWidth: 180, align: "justify" });

    // Lista de condições e filtros
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Lista de condições e filtros aplicados", 10, 110);

    let y = 120;
    const filtros = [
      ["Distrito:", distrito || "Não informado"],
      ["Frequência de exames: ", frequenciaExame || "-"],
      ["Atendimento de ambulância: ", atendimentoAmbulancia || "-"],
      ["Sistema de saúde: ", sistemaSaude || "-"],
      ["Uso de medicamentos: ", usoMedicamento || "-"],
      ["Dificuldade de atendimento: ", dificuldadeAtendimento || "-"],
      ["Possui doença crônica: ", possuiDoencaCronica || "-"],
      ["Tipo de doença crônica: ", tipoDoencaCronica || "-"],
      ["Programa de saúde rural: ", programaSaudeRural || "-"],
    ];

    doc.setFontSize(12);

    filtros.forEach(([label, valor]) => {
      // Marcador
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      // Label em negrito
      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 5, y);

      y += 6;
    });

    y += 5;
    // Indicadores
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Informações Gerais", 10, y);
    y += 10;

    const indicadores = [["Propriedades:   ", propriedades.value]];

    doc.setFontSize(12);

    indicadores.forEach(([label, valor]) => {
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 2, y);

      y += 6;
    });

    y += 5;

    doc.addImage(healthMapImage, "PNG", 20, y, 100, 80); // aumenta um pouco pra ver
  }

  static pageTwo(
    doc,
    propriedades,
    frequenciaExameImage,
    atendimentoAmbulanciaImage,
    sistemaSaudeImage,
    frequenciaExameData,
    atendimentoAmbulanciaData,
    sistemaSaudeData,
    imgSize,
  ) {
    let y = 40;

    doc.addImage(
      frequenciaExameImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      ${this.calcPercentual(frequenciaExameData["01 - A Cada 3 Meses"], propriedades)}% das propriedades fazem exames a 3 meses, ${this.calcPercentual(frequenciaExameData["02 - A Cada 6 Meses"], propriedades)}% a cada 6 meses, ${this.calcPercentual(frequenciaExameData["03 - Uma Vez ao Ano"], propriedades)}% fazem uma vez ao ano e ${this.calcPercentual(frequenciaExameData["04 - Menos de Uma Vez ao Ano"], propriedades)}% das propriedades fazem exames menos de uma vez ao ano e ${this.calcPercentual(frequenciaExameData["Não Informado"], propriedades)}% não informaram.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    y += 5;

    doc.addImage(
      atendimentoAmbulanciaImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      ${this.calcPercentual(atendimentoAmbulanciaData["01 - Inexistente"], propriedades)}% das propriedades classificam o atendimento como inexistente, ${this.calcPercentual(atendimentoAmbulanciaData["02 - Fraco"], propriedades)}% das propriedades classificam como FRACO, ${this.calcPercentual(atendimentoAmbulanciaData["03 - Médio"], propriedades)}% das propriedades classificam como médio e ${this.calcPercentual(atendimentoAmbulanciaData["04 - Efetivo"], propriedades)}% das propriedades classificam como efetivo.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    y += 5;

    doc.addImage(
      sistemaSaudeImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      ${this.calcPercentual(sistemaSaudeData["01 - Público"], propriedades)}% das propriedades utilizam o sistema de saúde público, enquanto ${this.calcPercentual(sistemaSaudeData["02 - Particular"], propriedades)}% das propriedades utilizam o sistema particular.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
  }

  static pageThree(
    doc,
    propriedades,
    usoMedicamentoImage,
    dificuldadeAtendimentoImage,
    qualidadeSSMunicipalImage,
    usoMedicamentoData,
    dificuldadeAtendimentoData,
    qualidadeSSMunicipalData,
    imgSize,
  ) {
    let y = 40;

    doc.addImage(
      usoMedicamentoImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      ${this.calcPercentual(usoMedicamentoData["01 - Não"], propriedades)}% das propriedades fazem uso de medicamentos enquanto ${this.calcPercentual(usoMedicamentoData["02 - Sim"], propriedades)}% das propriedades não fazem uso de medicamentos.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
    y += 5;

    doc.addImage(
      dificuldadeAtendimentoImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      ${this.calcPercentual(dificuldadeAtendimentoData["01 - Não"], propriedades)}% das propriedades possuem dificuldade de atendimento enquanto ${this.calcPercentual(dificuldadeAtendimentoData["02 - Sim"], propriedades)}% das propriedades não possuem dificuldade de atendimento.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
    y += 5;

    doc.addImage(
      qualidadeSSMunicipalImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      ${this.calcPercentual(qualidadeSSMunicipalData["01 - Inexistente"], propriedades)}% avaliaram a qualidade do sistema de saúde municipal como inexistente (${qualidadeSSMunicipalData["01 - Inexistente"]} propriedades), enquanto ${this.calcPercentual(qualidadeSSMunicipalData["02 - Ruim"], propriedades)}% como ruim (${qualidadeSSMunicipalData["02 - Ruim"]} propriedades), ${this.calcPercentual(qualidadeSSMunicipalData["03 - Regular"], propriedades)}% como regular (${qualidadeSSMunicipalData["03 - Regular"]} propriedades), ${this.calcPercentual(qualidadeSSMunicipalData["04 - Bom"], propriedades)}% como bom (${qualidadeSSMunicipalData["04 - Bom"]} propriedades) e ${this.calcPercentual(qualidadeSSMunicipalData["05 - Ótimo"], propriedades)}% como ótimo (${qualidadeSSMunicipalData["05 - Ótimo"]} propriedades).`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
    y += 5;
  }

  static pageFour(
    doc,
    propriedades,
    qualidadeSSRuralImage,
    possuiDoencaCronicaImage,
    tipoDoencaCronicaImage,
    qualidadeSSRuralData,
    possuiDoencaCronicaData,
    tipoDoencaCronicaData,
    imgSize,
  ) {
    let y = 40;

    doc.addImage(
      qualidadeSSRuralImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      ${this.calcPercentual(qualidadeSSRuralData["01 - Inexistente"], propriedades)}% avaliaram a qualidade do sistema de saúde rural como inexistente (${qualidadeSSRuralData["01 - Inexistente"]} propriedades), enquanto ${this.calcPercentual(qualidadeSSRuralData["02 - Ruim"], propriedades)}% como ruim (${qualidadeSSRuralData["02 - Ruim"]} propriedades), ${this.calcPercentual(qualidadeSSRuralData["03 - Regular"], propriedades)}% como regular (${qualidadeSSRuralData["03 - Regular"]} propriedades), ${this.calcPercentual(qualidadeSSRuralData["04 - Bom"], propriedades)}% como bom (${qualidadeSSRuralData["04 - Bom"]} propriedades) e ${this.calcPercentual(qualidadeSSRuralData["05 - Ótimo"], propriedades)}% como ótimo (${qualidadeSSRuralData["05 - Ótimo"]} propriedades).`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
    y += 5;

    doc.addImage(
      possuiDoencaCronicaImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      ${this.calcPercentual(possuiDoencaCronicaData["02 - Sim"], propriedades)}% das propriedades possuem doença crônica enquanto ${this.calcPercentual(possuiDoencaCronicaData["01 - Não"], propriedades)}% das propriedades não possuem`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
    y += 5;
    doc.addImage(
      tipoDoencaCronicaImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      Entre os entrevistados que possuem doença crônica, ${this.calcPercentual(tipoDoencaCronicaData["01 - Diabetes"], propriedades)}% indicam ter diabetes, ${this.calcPercentual(tipoDoencaCronicaData["02 - Hipertensão"], propriedades)}% indicam ter hipertensão, ${this.calcPercentual(tipoDoencaCronicaData["03 - Vascular"], propriedades)}% indicam ter doença vascular, ${this.calcPercentual(tipoDoencaCronicaData["04 - Asma"], propriedades)}% indicam ter asma, ${this.calcPercentual(tipoDoencaCronicaData["05 - Outra"], propriedades)}% indicam ter outras doenças e ${this.calcPercentual(tipoDoencaCronicaData["Não Informado"], propriedades)}% não informaram.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
  }

  static pageFive(
    doc,
    propriedades,
    programaSaudeRuralImage,
    programaSaudeRuralData,
    imgSize,
  ) {
    let y = 40;

    doc.addImage(
      programaSaudeRuralImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      ${this.calcPercentual(programaSaudeRuralData["01 - Não"], propriedades)}% das propriedades não participam de programa de saúde rural, enquanto ${this.calcPercentual(programaSaudeRuralData["02 - Sim"], propriedades)}% das propriedades participam.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
  }

  static calcPercentual(val, total) {
    const res = (val / total) * 100;
    return res.toFixed(2);
  }

  static gerarCabecalho(doc, logoEsq, logoDir) {
    // Logo à esquerda
    if (logoEsq) {
      doc.addImage(logoEsq, "PNG", 10, 10, 30, 20);
    }

    // Logo à direita
    if (logoDir) {
      doc.addImage(logoDir, "PNG", 170, 10, 30, 15);
    }

    // Título central
    doc.setFontSize(14);
    doc.text(
      "Relatório de saúde das propriedades rurais",
      doc.internal.pageSize.getWidth() / 2,
      15,
      { align: "center" },
    );
    doc.text(
      "cadastradas no censo agropecuário",
      doc.internal.pageSize.getWidth() / 2,
      21,
      { align: "center" },
    );

    // Informações extras
    doc.setFontSize(8);
    doc.text(`Data: ${new Date().toLocaleDateString()}`, 170, 28);

    // Linha divisória
    doc.setDrawColor(150);
    doc.line(10, 32, 200, 32);
  }

  static dataAtual() {
    const hoje = new Date();

    const data = hoje.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const formatada = data.replace(/\//g, "_");

    return formatada;
  }
}

export default PdfHealth;
